<script lang="ts">

    // COMPONENTS
    import { Table } from '@smatch/cassiopeia-web-components';
    import SubscriptionListItem from './SubscriptionListItem.svelte';

    // TYPES
    import type { Subscription } from 'src/app/types';

    /* PROPS --------------------------------------------------------------------------------- */

    export let subscriptions: Subscription[];

</script>

<Table>
    <svelte:fragment slot = 'header'>
        <tr class = 's8-table-header'>
            <th>Brand & Categories</th>
            <th>Pricing</th>
            <th>Minimum Amount</th>
            <th>Expiration Date</th>
            <th>Recommend Similar Brands</th>
            <th class = 's8-align-center'>Notifications</th>
            <th></th>
        </tr>
    </svelte:fragment>

    <svelte:fragment slot = 'body'>
        {#each subscriptions as subscription}
            <SubscriptionListItem { subscription } />
        {/each}
    </svelte:fragment>
</Table>

<style lang="postcss">
    th.s8-align-center {
        text-align: center !important;
    }

    @media (max-width: 700px) {
        tr.s8-table-header {
            display: none;
        }
    }
</style>